import React, { useState, useEffect } from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, TextField } from "@mui/material";

const cellSx = {
  backgroundColor: "rgba(47, 53, 71, 0.9)",
  border: "1.5px solid #fff",
  color: "white",
  padding: '10px 8px'
};
const numberSx = {
  ...cellSx,
  textAlign: 'left',
  fontWeight: 600,
};

const JustCauseInternalTable = ({
  salary = 0,
  christmasBonus = 0,
  accruedVacation = 0,
  total = 0
}) => {
  // Store editable accrued vacation as string for smooth editing
  const [editableAccruedVacation, setEditableAccruedVacation] = useState(String(accruedVacation));

  // Sync prop changes to state if accruedVacation prop changes
  useEffect(() => {
    setEditableAccruedVacation(String(accruedVacation));
  }, [accruedVacation]);

  // Handle change for accrued vacation input, allow empty or numeric only
  const handleAccruedVacationChange = (event) => {
    const val = event.target.value;
    // Accept empty string or valid decimal number
    if (val === '' || /^\d*\.?\d*$/.test(val)) {
      setEditableAccruedVacation(val);
    }
  };

  // Calculate updated total based on editableAccruedVacation and other props
  const calculatedTotal =
    (Number(salary) || 0) +
    (Number(christmasBonus) || 0) +
    (Number(editableAccruedVacation) || 0);

  // Format helpers for display
  const formatNum = (num) => num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const rows = [
    ["Salario Real", formatNum(Number(salary)), "Basado en el último mes completo o parcial trabajado"],
    ["Aguinaldo", formatNum(Number(christmasBonus)), "Total / Proporcional al tiempo trabajado en el año"],
    [
      "Vacacione Causadas",
      <TextField
        value={editableAccruedVacation}
        onChange={handleAccruedVacationChange}
        variant="standard"
        inputProps={{
          style: { color: 'white', padding: '6px 8px', fontWeight: 600 },
          inputMode: 'decimal',
          autoComplete: 'off',
          spellCheck: false,
        }}
        sx={{
          '& .MuiInputBase-input': { textAlign: 'left', color: 'white' },
          width: '120px',
        }}
      />,
      "Se concede sólo si hay más de 1 año de servicio."
    ],
  ];

  return (
    <Box mt={4}>
      <Typography variant="h6" mb={2} fontWeight="bold" color="white">
        Despido con Justa Causa – Interno
      </Typography>
      <TableContainer component={Paper} sx={{ background: 'rgba(47,53,71,0.9)' }}>
        <Table>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell sx={cellSx}>{row[0]}</TableCell>
                <TableCell sx={numberSx}>{row[1]}</TableCell>
                <TableCell sx={cellSx}>{row[2]}</TableCell>
              </TableRow>
            ))}
            {/* Total row */}
            <TableRow>
              <TableCell sx={{ ...cellSx, fontWeight: 700 }}>
                <Box>Total a Pagar</Box>
              </TableCell>
              <TableCell colSpan={2}
                sx={{
                  ...numberSx,
                  background: "rgba(34,189,110,0.15)",
                  color: "#3afa60",
                  fontWeight: "bold",
                  textAlign: 'center',
                  fontSize: 20,
                }}
              >
                {formatNum(calculatedTotal)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default JustCauseInternalTable;
